import type { VenueClientModule } from "../types";
import { buildSportsScene } from "./scene";
import { SportsCompact } from "./SportsCompact";
import { SportsHud } from "./SportsHud";

/** Townsy Sports Center on the client (ADR-0016): courts, balls, rackets, the AI players and the context controls. */
export const sportsCenterClient: VenueClientModule = {
  kind: "sports_center",
  build3d: buildSportsScene,
  Hud: SportsHud,
  Compact: SportsCompact,
};
